import React, { useContext } from 'react'
import { StateContext } from '../../services/StateService'
import { useIsDesktop } from '../../services/UtilityService'
import Benefits from '../../components/Benefits'
import DataSheets from './DataSheets'
import DiscontinuedZone from './DiscontinuedZone'
import DisclaimerLinks from '../../components/DisclaimerLinks'
import Link from '@3mcom/mds-library/dist/node/Link'
import { Translations } from '../../services/TranslationService'
import { DATA_SHEET_EXCLUDED_DIVISION_CODE } from '../../constants/UtilityConstants'
import { PDP_DETAILS_ID } from '../../constants/PDPConstants'
import scrollService from '../../services/ScrollService'
import '../../css/DescriptionZone.scss'
import ProductMiniTable from '../../components/ProductMiniTable'

const DescriptionZone = ({ showDetails }) => {
    const isDesktop = useIsDesktop()
    const {
        isParent,
        benefits,
        tds,
        sds,
        replacement,
        instructions,
        productDetails,
        moreOptions
    } = useContext(StateContext)

    const translations = useContext(Translations)

    const showDataSheets =
        isDesktop &&
        !DATA_SHEET_EXCLUDED_DIVISION_CODE.includes(productDetails.divisionCode) &&
        (tds?.length > 0 || sds?.length > 0 || instructions?.length > 0)

    const showMiniTable =
        !isParent &&
        moreOptions?.displayTable === true &&
        moreOptions?.classificationAttributes?.length > 0

    return (
        <div className="sps2-pdp_description--container">
            {showMiniTable && <ProductMiniTable />}
            <Benefits benefits={benefits?.slice(0, 3)} />
            {showDetails && isDesktop && (
                <Link
                    className="mds-link mds-link_primary mds-margin_medium--top"
                    onClick={() => scrollService.scrollToSection(PDP_DETAILS_ID)}
                >
                    {translations.viewMoreDetails}
                </Link>
            )}
            {showDataSheets && <DataSheets />}
            {replacement?.discontinued && <DiscontinuedZone />}
            {isDesktop && <DisclaimerLinks />}
            {/* COMMENTED UNTIL THE BEHAVIOR IS CLEAR */}
            {/* <button className="sps2-pdp_description--terms-conditions mds-link_secondary">
                {translations.termsAndConditions}
            </button> */}
        </div>
    )
}

export default DescriptionZone
